import React from 'react';
import { StyleSheet, Text, View, Image } from 'react-native';

import IMAGES from 'shared/constants/images';
import Button from 'shared/modules/common/components/atoms/Button';
import generateID from 'shared/modules/common/utils/generate-id';

type Props = {
  onCloseButtonPress: () => void;
};

const EmailReminderPhoneSuccess = (props: Props) => {
  return (
    <View
      style={style.container}
      {...generateID('step3-email-reminder-dialog')}
    >
      <View style={style.topSectionCenter}>
        <Image source={{ uri: IMAGES.success }} style={style.successImg} />
        <Text style={[style.title, style.textCenter]}>
          {`ご登録のメールアドレスを\nSMSに送信しました。`}
        </Text>
      </View>
      <Button
        title={'閉じる'}
        onPress={props.onCloseButtonPress}
        style={style.button}
        id="close-email-reminder-dialog"
      />
    </View>
  );
};

const style = StyleSheet.create({
  container: {
    flex: 1,
  },
  topSectionCenter: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: 20,
    lineHeight: 24,
    fontWeight: '600',
    color: '#2a2e32',
    marginBottom: 24,
  },
  textCenter: {
    alignSelf: 'center',
    textAlign: 'center',
  },
  button: {
    alignSelf: 'center',
    marginVertical: 8,
  },
  successImg: {
    width: 204,
    aspectRatio: 1,
    marginTop: 32,
    marginBottom: 24,
  },
});

export default EmailReminderPhoneSuccess;
